import React from 'react';
import { fmtMoney } from '../../utils/money';
import { fmtDate } from '../../utils/dates';
import PaymentBadge from './PaymentBadge';

// بطاقة عقد: رأس بالحالة وعدّاد المتبقي، جدول بنود، صف مالي ختامي.
export default function ContractCard({ contract }) {
  const c = contract;
  const active = c.status === 'active';
  const deficit = c.total_remaining < 0;

  return (
    <div className="card" style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15 }}>
            {c.title}
            {c.contract_no && <span style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 400 }}> — العقد {c.contract_no}</span>}
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
            {c.start_date ? fmtDate(c.start_date) : '—'} ← {c.end_date ? fmtDate(c.end_date) : '—'}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
          {active
            ? <span className="badge badge-completed">ساري</span>
            : c.status === 'ended'
              ? <span className="badge badge-cancelled">منتهٍ</span>
              : <span className="badge badge-pending">غير محدّد</span>}
          {active && c.days_remaining != null && (
            c.days_remaining < 0
              ? <span className="badge badge-cancelled" title="تجاوز تاريخ الانتهاء">⏳ متأخّر {Math.abs(c.days_remaining)} يوم</span>
              : <span className="badge badge-low" title="المتبقّي للانتهاء">
                  ⏳ {c.days_remaining} يوم{c.days_remaining >= 30 ? ` (≈ ${Math.round(c.days_remaining / 30)} شهر)` : ''}
                </span>
          )}
          {c.amendments?.length > 0 && <span className="badge badge-medium">📎 ملحق</span>}
          <PaymentBadge status={c.payment_status} />
        </div>
      </div>

      {c.amendments?.length > 0 && (
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>
          {c.amendments.map((a) => (
            <span key={a.id} style={{ marginInlineEnd: 10 }}>📎 {a.title} ({fmtDate(a.effective_date)})</span>
          ))}
        </div>
      )}

      <div className="table-wrap" style={{ marginTop: 10 }}>
        <table>
          <thead>
            <tr>
              <th>البند</th>
              <th>المنفّذ</th>
              <th>الكمية</th>
              <th>السعر</th>
              <th>بدء الاحتساب</th>
              <th>السقف</th>
              <th>المستهلَك</th>
              <th>المتبقّي</th>
            </tr>
          </thead>
          <tbody>
            {c.items.map((it) => (
              <tr key={it.id}>
                <td style={{ fontWeight: 500 }}>
                  {it.name_ar}
                  {it.region === 'inside_riyadh' && <span className="badge badge-low" style={{ marginInlineStart: 4 }}>داخل</span>}
                  {it.region === 'outside_riyadh' && <span className="badge badge-medium" style={{ marginInlineStart: 4 }}>خارج</span>}
                  {it.has_amendment && <span className="badge badge-medium" style={{ marginInlineStart: 4 }} title="سعر معدّل بملحق">📎 سعر</span>}
                  {it.used_amount_manual != null && <span className="badge badge-pending" style={{ marginInlineStart: 4 }} title="تجاوز يدوي">يدوي</span>}
                </td>
                <td>{it.executed_label || '—'}</td>
                <td>{it.effective_quantity ?? it.quantity ?? '—'}</td>
                <td>{it.unit_price != null ? fmtMoney(it.unit_price) : '—'}</td>
                <td>
                  {it.service_start_date ? fmtDate(it.service_start_date) : '—'}
                  {it.months_elapsed != null && <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>{it.months_elapsed} شهر منفّذ</div>}
                </td>
                <td>{it.ceiling_amount != null ? fmtMoney(it.ceiling_amount) : '—'}</td>
                <td>{fmtMoney(it.used_amount)}</td>
                <td>
                  {fmtMoney(it.remaining_amount)}
                  {it.overrun_amount > 0 && <div style={{ fontSize: 10, color: 'var(--danger)' }}>تجاوز {fmtMoney(it.overrun_amount)}</div>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 10, fontSize: 13, paddingTop: 8, borderTop: '1px solid var(--border)' }}>
        <span>المستنفَذ: <b>{fmtMoney(c.total_used)}</b></span>
        {c.carried_in > 0 && <span style={{ color: 'var(--success)' }}>المرحَّل إليه: +{fmtMoney(c.carried_in)}</span>}
        {c.carried_out > 0 && <span style={{ color: 'var(--danger)' }}>المحوَّل منه: −{fmtMoney(c.carried_out)}</span>}
        <span>التمويل الفعّال: <b>{fmtMoney(c.effective_funding)}</b></span>
        <span style={{ color: deficit ? 'var(--danger)' : 'inherit' }}>
          {deficit ? 'العجز' : 'المتبقّي'}: <b>{fmtMoney(Math.abs(c.total_remaining))}</b>
        </span>
      </div>
    </div>
  );
}
